export enum CareerPathType {
  Salary = 'Salary',
  Bonus = 'Bonus',
}
